@if (ticket.isHidden) {
    <button class="dropdown-item" type="button" (click)="hidePost()" translate>Show post</button>
} @else {
    <button class="dropdown-item" type="button" (click)="openHidePostModal()" translate>Hide post</button>
}
